import React, {Component} from 'react'

class MediaList extends Component {

  displayMediaFileFormate(type){
    var itemClass;

    switch (type) {

      case 'audio':
          itemClass = {
            mediaClass : 'sp-pagebuilder-media-audio',
            icon: 'fa fa-music'
          }
        break;

      case 'video':
          itemClass = {
            mediaClass : 'sp-pagebuilder-media-video',
            icon: 'fa fa-film'
          }
        break;

      case 'doc':
      case 'docx':
      case 'odt':
          itemClass = {
            mediaClass : 'sp-pagebuilder-media-attachment-document',
            icon: 'fa fa-file-word-o'
          }
        break;

      case 'key':
      case 'ppt':
      case 'pptx':
      case 'pps':
      case 'ppsx':
          itemClass = {
            mediaClass : 'sp-pagebuilder-attachment-presentation',
            icon: 'fa fa-file-powerpoint-o'
          }
        break;

      case 'xls':
      case 'xlsx':
          itemClass = {
            mediaClass : 'sp-pagebuilder-media-attachment-excel',
            icon: 'fa fa-file-excel-o'
          }
        break;

      case 'pdf':
          itemClass = {
            mediaClass : 'sp-pagebuilder-media-attachment-pdf',
            icon: 'fa fa-file-pdf-o'
          }
        break;

      case 'zip':
          itemClass = {
            mediaClass : 'sp-pagebuilder-media-attachment-zip',
            icon: 'fa fa-file-archive-o'
          }
        break;

      default:
        itemClass = {
          mediaClass : 'sp-pagebuilder-media-attachment-zip',
          icon: 'fa fa-file-archive-o'
        }
    }

    return itemClass;
  }

  displayMediaFile(item) {
    let itemClass   = this.displayMediaFileFormate(item.type)
    let splitIndex  = item.path.lastIndexOf('/')
    let fileName    = item.path.substr(splitIndex+1)

    if (item.type == 'image') {
      let imageThumb = item.thumb
      if ( imageThumb == '' ) {
        imageThumb = item.path
      }

      return(
        <div>
          <div>
            <div>
              <div>
                <img src = { pagebuilder_base + imageThumb }/>
              </div>
            </div>
          </div>
          <span className="sp-pagebuilder-media-title"><span><i className="fa fa-picture-o"></i> <span>{ fileName }</span></span></span>
        </div>
      )
    } else {
      return(
        <div>
          <div>
            <div>
              <div>
              <div>
                <div className={ itemClass.mediaClass }>
                  <i className={ itemClass.icon }></i>
                </div>
              </div>
              </div>
            </div>
          </div>
          <span className="sp-pagebuilder-media-title"><span><i className={ itemClass.icon }></i> <span>{ fileName }</span></span></span>
        </div>
      )
    }
  }

  handleItemClick(item){
    if (this.props.activeItem.id == item.id) {
      item = '';
    }
    this.props.onHandleItemClick(item);
  }

  render(){
    return(
      <ul className="sp-pagebuilder-media clearfix">
        <li className="sp-pagebuilder-media-file-loader" style={{display:'none'}}>
          <div>
            <div>
              <div>
                <div>
                  <div className="sp-pagebuilder-media-upload-progress">
                    <div>
                      <div className="sp-pagebuilder-progress">
                        <div className="sp-pagebuilder-progress-bar" style={{width: '0%'}}></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <span className="sp-pagebuilder-media-title"><i className="fa fa-circle-o-notch fa-spin"></i> UPLOADING...</span>
          </div>
        </li>
        {
          this.props.items.map((item, index) => {

              var itemCustomCls = 'sp-pagebuilder-media-item';
              if (item.id == this.props.activeItem.id) {
                itemCustomCls += ' selected'
              }
              if ( item.type !== this.props.supported ) {
                itemCustomCls += ' sp-pagebuilder-media-unsupported'
              }

            return(
              <li
                key={index}
                onClick={(e)=>{
                  e.preventDefault();
                  if ( item.type !== this.props.supported ) {
                    return;
                  }
                  this.handleItemClick(item);
                }}
                className={itemCustomCls}
              >
                { this.displayMediaFile(item) }
              </li>
            )
          })
        }
      </ul>
    )
  }
}

export default MediaList;



// WEBPACK FOOTER //
// ./src/helpers/form/types/media-helper/MediaList.js